import { GithubProvider } from './providers/github/GithubProvider.esm.js';
import { ANNOTATION_LOCATION } from '../utils/contants/annotations.esm.js';
import { extractGitHubInfo } from '../utils/helpers/extractGithubInfo.esm.js';

class VulnerabilitiesClient {
  constructor(configApi, catalogApi) {
    this.configApi = configApi;
    this.catalogApi = catalogApi;
    this.githubProvider = new GithubProvider(this.configApi);
  }
  githubProvider;
  // Checkar como será a destinção entre os providers e o tipo que será listado na tabela, sugiro incorporar um filtro
  async fetchVulnerabilitiesFromRepositoryList(repos) {
    return await this.githubProvider.fetchVulnerabilitiesFromRepositoryList(repos);
  }
  // TODO filter para listar mais opções de entidades e/ou todas
  async fetchVulnerabilitiesFromCatalogEntities() {
    const entities = await this.catalogApi.getEntities({
      filter: { kind: "Component", "spec.type": "service" }
      //TODO remover hardcoded
    });
    const entitiesRepoProps = entities.items.map((entity) => {
      const location = entity.metadata.annotations[ANNOTATION_LOCATION];
      const { owner, repo } = extractGitHubInfo(location);
      return { owner, name: repo };
    });
    return this.fetchVulnerabilitiesFromRepositoryList(entitiesRepoProps);
  }
  async fetchVulnerabititiesFromRepository(location) {
    return await this.githubProvider.fetchVulnerabititiesFromRepository(location);
  }
}

export { VulnerabilitiesClient };
//# sourceMappingURL=vulnerabititilesClient.esm.js.map
